import type { FaireProductEntity } from "../../entity_types/product";

export const p_75ucmrbbqj: FaireProductEntity = {
  token: "p_75ucmrbbqj",
  type: "product",
  name: "Arkansas Quartz Crystal Perky Box Display (Assorted)",
  brandToken: "b_nwecvb9e2v",
  brandName: "Enchanted Soul",
  imageUrl:
    "https://cdn.faire.com/fastly/9a16ee5b89c97662e18a504d2be428cfc81f6c1024a34959fb7dc7cdfe562e17.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/1003717149aa34bd9094352b7a4e1e50d973cdc8ea36d73ca437e47749e3c95d.jpeg",
    "https://cdn.faire.com/fastly/67d88d1841c4dc405536f33195820e74e49e3856942ea617679da7c72adebff4.jpeg",
    "https://cdn.faire.com/fastly/0e51df5c3da87c074296306dce37b18a193c55081682946dc8bcbf62d85a226b.jpeg",
    "https://cdn.faire.com/fastly/d121cf75556b3af87fcd2632a1d0471ae420f6038032b496306eb1d08a08ed4e.jpeg",
    "https://cdn.faire.com/fastly/d74dae1ee82d15eaf1fc02b55c108ce00713966fe344d70ac59560b51b6d9033.jpeg",
  ],
  priceDollars: 8.99,
  description:
    "Showcase the natural beauty of Arkansas quartz with our Perky Box Display Crystals, perfect for collectors and crystal enthusiasts. Each perky box contains a hand-selected high-quality Arkansas quartz crystal, known for its exceptional clarity, stunning formations, and powerful metaphysical properties.\n\nFeatures:\nAuthentic Arkansas Quartz – Ethically sourced from the renowned quartz mines of Arkansas, these crystals exhibit dazzling clarity and unique growth patterns.\nProtective Perky Box – Each crystal is securely housed in a 1.35” acrylic perky box, keeping it safe from dust and damage while allowing for a clear, professional display.\nCollector’s Favorite – Ideal for personal collections, or as a thoughtful gift for any crystal lover.",
  tags: [],
  msrpDollars: 18,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:55:28.925Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
